import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { withdraw } from '../actions/accountActions';

const WithdrawPage: React.FC = () => {
  const accountsList = useSelector((state: appState) => state.accountsList);
  const { accounts, wsuccess, error } = accountsList;

  const [amount, setAmount] = useState('1.00');
  const [number, setNumber] = useState(accounts[0].number);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  useEffect(() => {
    if (!userData) {
      navigate('/');
    }
  }, [navigate, userData]);

  const lastFour = (str: string) => {
    return str.slice(-4);
  };

  const cancelHandler = () => {
    navigate('/account');
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const numAmount = parseFloat(amount).toFixed(2);

    const withdrawAmount = parseFloat(numAmount);

    dispatch(withdraw(number, withdrawAmount));

    setTimeout(() => {
      navigate('/account');
    }, 2000);
  };

  return (
    <div className='account-page'>
      <Navigation />
      <form className='transaction-form' onSubmit={submitHandler}>
        <label htmlFor='withdraw-amount'>Withdrawal Amount ($):</label>
        <input
          type='number'
          name='withdraw-amount'
          id='withdraw-amount'
          className='transaction-input'
          min='0.01'
          step='0.01'
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <p>Select account to withdraw from: </p>
        <select
          name='withdraw-select'
          id='withdraw-select'
          className='transaction-select'
          onChange={(e) => setNumber(e.target.value)}
        >
          {accounts.map((account) => (
            <option key={account.id} value={account.number}>
              {account.type} {lastFour(account.number)}
            </option>
          ))}
        </select>
        <div className='transaction-buttons'>
          <button className='cancel-btn' onClick={cancelHandler}>
            Cancel
          </button>
          <button type='submit' className='submit-btn withdraw-btn'>
            Withdraw
          </button>
        </div>
        {wsuccess && (
          <p className='w-success'>
            Your withdrawal has been made successfully!
          </p>
        )}
        {error && <p className='t-error'>{error}</p>}
      </form>
    </div>
  );
};

export default WithdrawPage;
